export type LogoProps = {
  size?: "sm" | "md" | "lg";
  /**
   * When true, applies a CSS brightness-invert filter so the black logo
   * artwork renders white — no background box needed.
   */
  onDark?: boolean;
  className?: string;
};

const SIZE_PX: Record<NonNullable<LogoProps["size"]>, number> = {
  sm: 70,
  md: 68,
  lg: 96,
};

export function Logo({ size = "md", onDark = false, className }: LogoProps) {
  const height = SIZE_PX[size];
  const width = Math.round(height * (248 / 150));

  return (
    <span
      className={["inline-flex items-center", className ?? ""]
        .filter(Boolean)
        .join(" ")}
    >
      <img
        src={onDark ? "/images/membertou-boxing-logo-white.svg" : "/images/membertou-boxing-logo-black.svg"}
        alt="Membertou Boxing Club"
        width={width}
        height={height}
        decoding="async"
        className="block"
        style={{ height, width }}
      />
    </span>
  );
}

